import vCache from '@/utils/vCache';
import { string, object, number } from 'yup';



export const CreateOrUpdateRelativesInfoValidation = vCache('CreateOrUpdateRelativesInfoValidation', (t) => object({
  relation: string().required().min(3).max(50).label(t('survey:labels.relation')),
  firstName: string().required().min(3).max(50).label(t('survey:labels.firstname')),
  lastName: string().required().min(10).max(15).label(t('survey:labels.lastname')),
  studyLevelId: number().required().label(t('survey:labels.study-level-id')),
  age: number().required().min(3).max(50).label(t('survey:labels.age')),
  contactInfo: string().required().min(3).max(50).label(t('survey:labels.contact-info')),
  address: string().required().min(3).max(50).label(t('survey:labels.address')),
}).noUnknown());
